import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { ContracteProgramariService } from '../contracte-programari.service';
import { map, Subject, takeUntil } from 'rxjs';
import { Contract } from '../contracte-programari.interface';
import { NotificationService } from 'src/app/services/notification.service';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import { AppFilesService } from 'src/app/services/app-files.service';
import { OperatorAccess, UserFunction } from 'src/app/platform/nomenclatoare/operatori/operatori.interface';
import { OperatoriService } from 'src/app/platform/nomenclatoare/operatori/operatori.service';

@Component({
    selector: 'app-contracte-programari-detalii',
    templateUrl: './contracte-programari-detalii.component.html',
    styleUrls: ['./contracte-programari-detalii.component.scss']
})
export class ContracteProgramariDetaliiComponent implements OnInit, OnDestroy {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    private destroy$ = new Subject<void>();

    isLoading = false;
    passedContractId: number = this.data;
    contract: Contract | null = null;

    user: any = null;
    userFunctions: UserFunction[] = [];
    activeFunction: UserFunction | null = null;
    userAccesses: OperatorAccess[] = [];
    activeAccess: OperatorAccess | null = null;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: number,
        private dialogRef: MatDialogRef<ContracteProgramariDetaliiComponent>,
        private contracteProgramariService: ContracteProgramariService,
        private storageService: StorageService,
        private notificationService: NotificationService,
        private appFilesService: AppFilesService,
        private operatoriService: OperatoriService,
    ) { }

    ngOnInit(): void {
        this.processUserDetails();
        this.getContractInfo();

        this.loadUserFunctions();
        this.loadUserAccess();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    processUserDetails() {
        var self = this;
        const userObj = self.storageService.getObject(environment.config.userKey);
        userObj
            .then((val) => {
                self.user = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    loadUserFunctions(): void {
        this.operatoriService.userFunctions$
            .pipe(takeUntil(this.destroy$))
            .subscribe(userFunctions => {
                this.userFunctions = userFunctions;
                this.activeFunction = this.userFunctions.find(func => func.is_active) || null;
            });
    }

    loadUserAccess(): void {
        this.operatoriService.userAccess$
            .pipe(takeUntil(this.destroy$))
            .subscribe(userAccesses => {
                this.userAccesses = userAccesses;
                this.activeAccess = this.userAccesses.find(access => access.active) || null;
            });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    onIsLoadingChange(event: boolean) {
        this.isLoading = event;
    }

    getContractInfo() {
        this.isLoading = true;
        this.contracteProgramariService
            .getContract(this.passedContractId)
            .pipe(map((response: any) => response.data))
            .subscribe({
                next: (contractData: Contract) => {
                    this.isLoading = false;
                    this.contract = contractData;
                },
                error: (error: any) => {
                    this.isLoading = false;

                    let msg;
                    try {
                        msg = error.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService
                        .warningSwal(this.errorTitle, msg, this.errorIcon)
                        .then((result) => {
                            this.closeDialog();
                        });
                }
            });
    }

    formatDate(dateStr: string | null | undefined): string {
        if (!dateStr) return 'N/A';
        const [year, month, day] = dateStr.split('-');
        return `${day}.${month}.${year}`;
    }

    downloadFile(id: number) {
        this.isLoading = true;
        const fullPath = this.contracteProgramariService.printContractUrl + id;

        this.appFilesService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(err => {
                console.error('Download doc error: ', err);
                this.isLoading = false;
            })
    }

    reziliereContract(id: number) {
        this.isLoading = true;

        this.contracteProgramariService.reziliereContract(id).subscribe({
            next: (res) => {
                this.isLoading = false;
                this.getContractInfo();
            },
            error: (err) => {
                console.log(err);
                this.isLoading = false;
            }
        })
    }
}
